const sectionPrefix = 'shopify-section';

/**
 * @param {string} name
 * @description Gets data for specific theme section
 */
export default class ThemeSection {
  constructor(name) {
    this._name = name;
  }

  get name() {
    return this._name || '';
  }

  get container() {
    return this._container;
  }

  get data() {
    return this._data;
  }

  /**
   * @description Returns container element for theme section
   */
  _getSectionElementByName() {
    const el = document.getElementById(`${sectionPrefix}-${this.name}`);

    if (!el) {
      throw new Error(`Theme Section: Element "${this.name}" does not exist`);
    }

    return el;
  }

  /**
   * @description Returns JSON for theme section if available
   */
  _getSectionDataByName() {
    const el = document.querySelector(
      `[type="application/json"][data-section-id="${this.name}"]`
    );

    if (el) {
      try {
        return JSON.parse(el.innerHTML);
      } catch (e) {
        throw new Error(
          `Theme Section: Invalid JSON for section "${this.name}"`
        );
      }
    }

    return null;
  }

  init() {
    this._container = this._getSectionElementByName();
    this._data = this._getSectionDataByName();
  }

  /**
   * @param {CustomEvent} event
   * @param {Function} callback
   * @description Handles events triggered by Shopify when manipulating sections in the admin.
   * The custom event will pass a sectionId for the section that was edited in the admin.
   * This insures that the callback only happens for the section it's associated to.
   */
  handleEvent(event, callback) {
    if (!event || !event.detail) {
      throw new Error('invalid event passed to section');
    }

    if (event.detail.sectionId === this.name) {
      callback(event);
    }
  }

  /**
   * @param {string} eventName
   * @param {Function} callback
   * @description Listens for specific event for the current theme section
   */
  on(eventName, callback) {
    document.addEventListener(`shopify:section:${eventName}`, e =>
      this.handleEvent(e, callback)
    );
  }
}
